export default __webpack_public_path__ + "static/media/369.2ca1dd6d.gif";